<template>
  <div>
    <div class="backg">
      <div class="content___1ZfD3">
        <div class="list___wypX_">
          <div class="type_title titleWrapper___2qZKS">
            <h1 class="live_type" style="color: #05a2ff">我的预约</h1>
          </div>
          <div class="item_list" v-if="list.length > 0">
            <div
              class="liveswill"
              v-for="(item, index) in list"
              :key="'liveswill' + index"
            >
              <p class="item_title">
                <span class="title_name">
                  <span>{{ item.group.egName }}频道</span>
                  <span class="title_time">{{ getTimes(item.lDt) }}</span>
                </span>
              </p>
              <div class="con" @click="toDetails(item.lId)">
                <img
                  class="con_images"
                  :src="item.lPicUrl"
                  alt=""
                  v-if="item.lPicUrl"
                />
                <img
                  class="con_images"
                  src="../../assets/images/default.png"
                  alt=""
                  v-else
                />
                <div class="con_right">
                  <p class="con_title">{{ item.lTitle }}</p>
                  <div>
                    <p class="con_author">{{ item.lSpeaker }}</p>
                    <!--<p class='con_org'>{{item.lOrg}}</p>-->
                  </div>
                </div>
              </div>
              <div class="last">
                <span>预约人数：{{ item.lAppointNum }}人</span>
                <button
                  class="footer_yybm"
                  @click="signUp(item.lIsAppoint, index, item.lId)"
                  :style="{
                    background: item.lIsAppoint == 1 ? '#999999' : '#FFB441',
                  }"
                >
                  {{ item.lIsAppoint == 1 ? "已预约" : "预约报名" }}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="none" v-if="list.length < 1">
      <img src="../../assets/images/nonelist.png" alt="" />
      <p>暂无预约</p>
    </div>
  </div>
</template>
<script>
import AppSetting from '../../AppSetting';
import loginService from "../../plugin/extendFn/loginService";
export default {
  data() {
    return {
      l_type: [
        { name: "注册与检测", id: 1 },
        { name: "质量体系", id: 2 },
        { name: "临床试验与评价", id: 3 },
        { name: "上市后经营与监管", id: 4 },
        { name: "产品市场与销售", id: 5 },
      ],
      list: [],
      wxuser: null,
      ra_wxUser: null
    };
  },
  props: {},
  methods: {
    login() {
      loginService.login(this.$router).then((loginUser) => {
        this.ra_wxUser = loginUser;
      });
    },

    getTimes(value) {
      return new Date(value).Format("yyyy.MM.dd hh:mm");
    },
    getList() {
      this.$postHttp(AppSetting.baseUrl + "/student/appointment", {
        id: this.wxuser.uId,
      }).then((res) => {
        // console.log(res);
        if (res.data.code == 0) {
          this.list = res.data.list;
        }
      });
    },
    getTimesm(value) {
      return new Date(value).Format("MM");
    },
    getTimesd(value) {
      return new Date(value).Format("dd");
    },
    getTimest(value) {
      return new Date(value).Format("hh:mm");
    },
    toDetails(id) {
      this.$router.push({
        name: "Details",
        query: { type: "live", liveId: id },
      });
    },
    async signUp(status, index, lid) {
      localStorage.setItem("userLiveId", lid);
      localStorage.setItem("usertype", 1);
      if (await loginService.isNotLogin()) {
        this.login();
      } else {
        if (status == 0) {
          this.$postHttp(AppSetting.baseUrl + "/live/appointment", {
            uid: this.ra_wxUser
              ? this.ra_wxUser.uId
                ? this.ra_wxUser.uId
                : ""
              : "",
            lid: lid,
          }).then((res) => {
            if (res.data.code == 0) {
              this.$set(this.list[index], "lIsAppoint", 1);
              this.$set(this.list[index], "lAppointNum", res.data.num);
              //参数：要改的对象、要改的key 、要改的值
              this.$message.success("预约成功");
            } else {
              this.$message.error("预约失败");
            }
          });
        } else {
          weui.dialog({
            content: "确定要取消预约吗？",
            className: "yors",
            buttons: [
              {
                label: "取消",
                type: "default",
                onClick: (res) => {
                  // alert('取消')
                },
              },
              {
                label: "确定",
                type: "primary",
                onClick: () => {
                  this.$postHttp(AppSetting.baseUrl + "/live/appointment/cancel", {
                    uid: this.ra_wxUser
                      ? this.ra_wxUser.uId
                        ? this.ra_wxUser.uId
                        : ""
                      : "",
                    lid: lid,
                  }).then((res) => {
                    if (res.data.code == 0) {
                      this.$set(this.list[index], "lIsAppoint", 0);
                      this.$set(this.list[index], "lAppointNum", res.data.num);
                      this.$message.success("取消成功");
                    } else {
                      this.$message.error("取消预约失败");
                    }
                  });
                },
              },
            ],
          });
        }
      }
    },
  },
  computed: {},
  async mounted() {
    this.wxuser = await loginService.getLoginUser();
    this.ra_wxUser = this.wxuser;
    this.getList();
  },
};
</script>
<style scoped lang="scss">
.none {
  width: 100%;
  min-height: 260px;
  box-sizing: border-box;
  text-align: center;
  img {
    width: 100px;
    display: inline-block;
    margin: 80px auto 0px;
    /*width: 100%;*/
  }
  p {
    font-size: 16px;
    color: #999999;
    text-align: center;
  }
}
.live_type {
  f-webkit-box-flex: 1;
  -ms-flex: 1 1;
  flex: 1 1;
  font-size: 26px;
  font-weight: 500;
  color: #007eff;
}
.backg {
  width: 100%;
  min-width: 1280px;
  overflow: hidden;
}
.content___1ZfD3 {
  width: 1280px;
  min-width: 1280px;
  padding-bottom: 24px;
  box-sizing: border-box;
  margin: 0 auto;
}
.last {
  display: flex;
  justify-content: space-between;
  span:nth-of-type(1) {
    font-size: 12px;
    font-weight: 300;
    color: #999;
    min-height: 12px;
  }
}
.last,
.type_title {
  button {
    border-radius: 25px;
    color: #ffffff;
    border: none;
    outline: none;
  }
}
.footer_type {
  color: #ffb400;
}
.footer_yybm {
  width: 60px;
  font-size: 12px;
  cursor: pointer;
}
.liveswill {
  border: 1px solid #e6e6e6;
  margin: 0px 24px 0 0;
  height: 260px !important;
  border-radius: 5px;
  display: -ms-flexbox;
  display: -webkit-box;
  display: flex;
  -ms-flex-direction: column;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  flex-direction: column;
  width: 232px;
  cursor: pointer;
  background: #fff;
  padding: 0 10px;

  float: left;
  /*margin: 24px 24px 0 0;*/
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  -ms-flex-pack: justify;
  -webkit-box-pack: justify;
  justify-content: flex-start;
  .con {
    margin-top: 6px;
  }
  .item_title {
    padding-top: 6px !important;
  }
  .title_name {
    font-size: 12px;
    color: #666666 !important;
    display: flex;
    justify-content: space-between;
    span:nth-of-type(1) {
      display: inline-block;
      width: 110px;
      -webkit-box-orient: vertical; /*设置弹性盒模型子元素的排列方式*/
      -webkit-line-clamp: 1; /*限制文本行数*/
      white-space: nowrap; /*超出的空白区域不换行*/
      overflow: hidden; /*超出隐藏*/
      text-overflow: ellipsis; /*文本超出显示省略号*/
    }
  }
  .con_images {
    width: 212px !important;
    height: 120px !important;
    border-radius: 5px !important;
  }
  .con_title {
    font-size: 14px !important;
    color: #333 !important;
    line-height: 18px !important;
    height: 39px !important;
    -webkit-box-orient: vertical; /*设置弹性盒模型子元素的排列方式*/
    -webkit-line-clamp: 2; /*限制文本行数*/
    overflow: hidden; /*超出隐藏*/
    text-overflow: ellipsis; /*文本超出显示省略号*/
  }

  .con_author {
    font-size: 12px !important;
    font-weight: 300 !important;
    color: #666666 !important;
    min-height: 14px !important;
    margin-top: 5px !important;
  }
  .last {
    padding: 0px !important;
    box-sizing: border-box !important;
    margin-top: 6px !important;
    height: 20px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/me/bespoke.vue